export function kFormatter(num: number, shouldHaveZero = false) {
	return Math.abs(num) > 999
		? String(num / (shouldHaveZero ? 1 : 1000)).replace(
				/\B(?=(\d{3})+(?!\d))/g,
				','
		  ) + (shouldHaveZero ? '' : 'k')
		: Math.sign(num) * Math.abs(num);
}

export const formatToCurrency = (amount: number | string): string => {
	return "$" + amount.toLocaleString('en-US');
};

export const formatAmountArray = (items: any[]) =>
	items.map((item: any) =>
		item['Amount']
			? { ...item, Amount: formatToCurrency(item?.Amount) }
			: item?.amount
			? { ...item, amount: formatToCurrency(item?.amount) }
			: item
	);